/**
 * Tags to categorize links in the Link Library
 */
export enum LinkTags {
  Analytics = 'analytics',
  API = 'api',
  Assets = 'assets',
  Career = 'career',
  Cloud = 'cloud',
  CodeManagement = 'code management',
  CodeQuality = 'code quality',
  Collaboration = 'collaboration',
  Data = 'data',
  Design = 'design',
  Documentation = 'documentation',
  Fashion = 'fashion',
  Frontend = 'frontend',
  IncidentManagement = 'incident management',
  Jobs = 'jobs',
  Learning = 'learning',
  Messaging = 'messaging',
  News = 'news',
  Observability = 'observability',
  ProjectManagement = 'project management',
  Prototyping = 'prototyping',
  QandA = 'Q&A',
  Support = 'support',
  Testing = 'testing',
  Tooling = 'tooling',
  Travel = 'travel',
  Trends = 'trends',
  BackstageProfile = 'Your Backstage Profile',
  BackstageTechDocs = 'TechDocs',
  BackstageCommunity = 'community',
}

/**
 * Type definition for a Link Library link in the Link Library
 */
export type LinkLibraryLink = {
  name: string;
  link: string;
  icon: React.ComponentType;
  description: string;
  tags: LinkTags[];
};
